import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { useCopyAPIKeyIntegration } from '../CopyAPIKeyModal/useCopyAPIKeyIntegration';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
import pingLogo from './ping-logo.png';
export const GetPingCardTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            PingCardTID: {
                Card: 'ping-card',
                Connect: 'ping-card-connect'
            }
        }
    });
export default function PingCard() {
    const { t: pingTexts } = useLocaleKeys('integrations.availableApps.ping');
    const { t: sharedTexts } = useLocaleKeys('integrations.availableApps.shared');
    const { showCopyAPIKeyModal } = useCopyAPIKeyIntegration('ping');
    const { PingCardTID } = useMemo(()=>GetPingCardTID(), []);
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: PingCardTID.Card(),
        icon: /*#__PURE__*/ _jsx(IntegrationCard.LogoImg, {
            alt: "ping logo",
            src: pingLogo
        }),
        title: pingTexts.title(),
        subTitle: pingTexts.subTitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            bi: {
                name: 'connect_ping'
            },
            onClick: showCopyAPIKeyModal,
            testId: PingCardTID.Connect(),
            children: sharedTexts.connectButton()
        })
    });
}
